import appReducer from './reducer';

export { default as appConfig } from './config';
export { default as appDictionary } from './dictionary';
export { default as appTypes } from './types';
export { default as appSelectors } from './selectors';

export default appReducer;